/** 管理端默认每页条数选项 */
export const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];

/** 门户卡片列表常用选项（含 3 列网格 9/12 等） */
export const PORTAL_CARD_PAGE_SIZES = [9, 12, 18, 24, 36, 48];

/**
 * 合并当前 pageSize 与候选值，保证下拉中始终包含当前选中项。
 * @param {number} current
 * @param {number[]} candidates
 */
export function mergePageSizes(current, candidates = DEFAULT_PAGE_SIZES) {
  const set = new Set((candidates || []).map(Number));
  const n = Number(current);
  if (n > 0) set.add(n);
  return Array.from(set).sort((a, b) => a - b);
}
